import { useEffect } from 'react';

/**
 * useEffect on mount only
 */
const useOnMountEffect = cb => {
  return useEffect(() => {
    cb();
  }, []);
};

export default useOnMountEffect;
